import React from 'react';
import { TimePicker } from 'antd';
import { FiClock } from 'react-icons/fi';
import { RadioButton } from '@Thread-Magic/jasmine';
import * as Styled from 'src/components/MessengerSettings/style';
import { RecommendedTag } from 'src/components/Copilot/CopilotGenerateTitle/styled';
import {
  RESPONSE_TYPES,
  THREAD_RESPONSE_TYPES,
  covertMinutesToDayjs,
  convertDayjsToMinutes
} from './constants';

const EstimateResponseTimeSection = ({ data, setData }) => {
  const handleLiveChatResponseTypeChange = e => {
    setData(old => ({ ...old, threadResponseType: e.target.value }));
  };

  const onTimeChange = dayjsTime => {
    setData(old => ({
      ...old,
      threadResponseTime: dayjsTime ? convertDayjsToMinutes(dayjsTime) : 0
    }));
  };

  const renderThreadResponseTypes = () => {
    return RESPONSE_TYPES.map(responseType => (
      <RadioButton
        key={responseType.id}
        id={responseType.id}
        checked={data.threadResponseType === responseType.id}
        value={responseType.id}
        onChange={handleLiveChatResponseTypeChange}
      >
        {responseType.label}
        {responseType.id === THREAD_RESPONSE_TYPES.DEFAULT_5_MINUTES && (
          <RecommendedTag>Recommended</RecommendedTag>
        )}
      </RadioButton>
    ));
  };

  return (
    <Styled.FormGroup>
      <Styled.SubTitle>Estimated response time</Styled.SubTitle>
      {renderThreadResponseTypes()}
      {data.threadResponseType === THREAD_RESPONSE_TYPES.CUSTOM && (
        <Styled.EstimeTimePickerWrapper>
          <TimePicker
            format="HH:mm"
            showNow={false}
            rootClassName="response-time-picker"
            popupClassName="response-time-picker-popup"
            activeBorderColor="red"
            prefix={<FiClock color="#bfbfbf" />}
            suffixIcon={null}
            presetsMaxWidth={500}
            size="large"
            getPopupContainer={trigger => trigger.parentNode}
            onChange={onTimeChange}
            defaultValue={covertMinutesToDayjs(data.threadResponseTime || '5')}
          />
          <Styled.EstimateLabel>Hours : Minutes</Styled.EstimateLabel>
        </Styled.EstimeTimePickerWrapper>
      )}
    </Styled.FormGroup>
  );
};

export default EstimateResponseTimeSection;
